var _defs, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _rect2, _use8, _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1300,
    height: 650,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "pt",
    points: "-0.1624598481164531,0 0,-0.5 0.1624598481164531,0",
    transform: "scale(0.0616)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.252
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.252
  })), /*#__PURE__*/React.createElement("g", {
    id: "s6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    x: -0.063
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.315
  })), /*#__PURE__*/React.createElement("g", {
    id: "x4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.054
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.108
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.162
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4",
    y: -0.216
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.216
  })), /*#__PURE__*/React.createElement("rect", {
    id: "stripe",
    width: 1300,
    height: 50,
    fill: "#B22234"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1300,
    height: 650,
    fill: "#FFF"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 100
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 200
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 300
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 400
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 500
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#3C3B6E"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    transform: "translate(247,175) scale(650)"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 30",
    width: 1300,
    height: 650,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15L60,30V15H0V30H30z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "uk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,30H60V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z",
    fill: "#00247d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,30 L30,15 L60,30",
    clipPath: "url(#t)",
    fill: "none",
    stroke: "#cf142b",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#cf142b",
    strokeWidth: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishLanguage);
export default __webpack_public_path__ + "static/media/English_language.1fa1bd7899270f986a4e6d8b9ba5afa1.svg";
export { ForwardRef as ReactComponent };